import React from 'react';
import PropTypes from 'prop-types';
import Accordion from '@Pages/ProfileSettings/Preferences/components/Accordion';
import { ProfileSettingsConfig } from '@Constants/rx-user/constants';

function UsernameSection({ value }) {
  return (
    <Accordion
      open={false}
      className="username-accordion-item"
      heading={
        <div className="rx-accordion-row profile-settings-accordion-row disabled">
          <span className="profile-settings-accordion-row_label">{ProfileSettingsConfig.Labels.username}</span>
          <span className="profile-settings-accordion-row_value">{value}</span>
        </div>
      }
    />
  );
}

UsernameSection.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default UsernameSection;
